/**
 * Parse a value of unknown type as a boolean or return undefined if the value is non-boolean.
 * @param value The value to parse as a boolean.
 */
export function parseAsBoolean<V extends `${BooleanBasic}`>(value: BooleanBasic | V): boolean | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  return value.toLocaleLowerCase() === 'yes';
}

export enum BooleanBasic {
  yes = 'Yes',
  no = 'No'
}
